import React, { useState } from "react";
import { MDBBtn as Button } from "mdb-react-ui-kit";
import Modal from "react-bootstrap/Modal";
import ReportPreview from "./PDF/Report-Preview";
import "../App.css";

function PDFModal({ show, handleClose, profile, imageUrl, ksa }) {
  return (
    <Modal show={show} size="lg" onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Export Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ReportPreview profile={profile} imageUrl={imageUrl} ksa={ksa} />
      </Modal.Body>
    </Modal>
  );
}

export default PDFModal;
